import { render, staticRenderFns } from "./leapfrog.vue?vue&type=template&id=82f187fa&"
import script from "./leapfrog.vue?vue&type=script&lang=js&"
export * from "./leapfrog.vue?vue&type=script&lang=js&"
import style0 from "./leapfrog.vue?vue&type=style&index=0&id=82f187fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports